import { DollarSign, TrendingUp, Wallet, Package } from 'lucide-react';
import { Badge } from '../ui/badge';

export function EarningsTab({ earnings }) {
  if (!earnings) return null;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-lime/10 rounded-xl flex items-center justify-center"><DollarSign className="w-6 h-6 text-lime" /></div>
            <div><p className="text-2xl font-mono font-bold text-lime">${earnings.total_platform_earnings.toFixed(2)}</p><p className="text-sm text-[#A1A1AA]">Total Platform Earnings</p></div>
          </div>
        </div>
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center"><TrendingUp className="w-6 h-6 text-blue-500" /></div>
            <div><p className="text-2xl font-mono font-bold">${earnings.this_month_earnings.toFixed(2)}</p><p className="text-sm text-[#A1A1AA]">This Month</p></div>
          </div>
        </div>
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-yellow-500/10 rounded-xl flex items-center justify-center"><Wallet className="w-6 h-6 text-yellow-500" /></div>
            <div><p className="text-2xl font-mono font-bold">${earnings.held_funds.toFixed(2)}</p><p className="text-sm text-[#A1A1AA]">Held in Escrow</p></div>
          </div>
        </div>
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center"><Package className="w-6 h-6 text-purple-500" /></div>
            <div><p className="text-2xl font-mono font-bold">${earnings.total_transaction_volume.toFixed(2)}</p><p className="text-sm text-[#A1A1AA]">Total Volume</p></div>
          </div>
        </div>
      </div>

      <div className="bg-surface border border-[#262626] rounded-xl p-6">
        <h3 className="font-heading font-bold mb-4">Platform Fee Structure</h3>
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
          <div className="p-4 bg-surface-highlight rounded-lg"><p className="text-3xl font-mono font-bold text-lime">5%</p><p className="text-sm text-[#A1A1AA]">Buyer Fee</p></div>
          <div className="p-4 bg-surface-highlight rounded-lg"><p className="text-3xl font-mono font-bold text-lime">5%</p><p className="text-sm text-[#A1A1AA]">Artist Fee</p></div>
          <div className="p-4 bg-surface-highlight rounded-lg"><p className="text-3xl font-mono font-bold">{earnings.total_completed_orders}</p><p className="text-sm text-[#A1A1AA]">Completed Orders</p></div>
          <div className="p-4 bg-surface-highlight rounded-lg"><p className="text-3xl font-mono font-bold">${earnings.pending_earnings?.toFixed(2) || '0.00'}</p><p className="text-sm text-[#A1A1AA]">Pending Earnings</p></div>
          <div className="p-4 bg-surface-highlight rounded-lg"><p className="text-3xl font-mono font-bold">${earnings.pending_fees?.toFixed(2) || '0.00'}</p><p className="text-sm text-[#A1A1AA]">Pending Fees</p></div>
        </div>
      </div>

      {earnings.recent_earnings && earnings.recent_earnings.length > 0 && (
        <div className="bg-surface border border-[#262626] rounded-xl overflow-hidden">
          <div className="p-4 border-b border-[#262626]"><h3 className="font-heading font-bold">Recent Platform Earnings</h3></div>
          <div className="divide-y divide-[#262626]">
            {earnings.recent_earnings.map((earning) => (
              <div key={earning.id} className="p-4 flex items-center justify-between">
                <div><p className="font-mono text-sm">Order #{earning.order_id.slice(0, 8)}</p><p className="text-xs text-[#A1A1AA]">{new Date(earning.created_at).toLocaleDateString()}</p></div>
                <div className="text-right">
                  <p className="font-mono text-lime">+${earning.amount.toFixed(2)}</p>
                  <Badge className="bg-green-500/10 text-green-400 border-0 text-xs">{earning.status}</Badge>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
